export const tabsEnum = {
	OVERVIEW: "All industries",
};

Object.freeze(tabsEnum);

export const tabsArray = Object.values(tabsEnum);
